import fetchExpresso from 'utility/fetchExpresso';

export async function getAdmissionPageProducts(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/products`);

    if (response.status !== 200) {
        throw new Error('Unable to load admission products');
    }

    return response.json();
}

export async function getAdmissionProducts(eventId) {
    const products = await getAdmissionPageProducts(eventId);
    return products.filter((product) => product.prod_type_id === 1);
}

export async function updateAdmissionSort(eventId, sort) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/products/sort`, {
        method: 'PUT',
        body: {
            type: 'ticket',
            sort,
        },
    });

    if (response.status !== 200) {
        throw new Error('Unable to change order');
    }
}

export async function updateAddonSort(eventId, sort) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/products/sort`, {
        method: 'PUT',
        body: {
            type: 'addon',
            sort,
        },
    });

    if (response.status !== 200) {
        throw new Error('Unable to change order');
    }
}
